const state = {
    sampleglasses: [],
    sampleglassescategories: [],
};

const getters = {
    sampleglasses: (state) => state.sampleglasses,
    sampleglassescategories: (state) => state.sampleglassescategories,
    sampleGlassInCart: (state) => (id) => {
        return state.sampleglasses.indexOf(id) > -1 ? true : false;
    },
    sampleCategoryInCart: (state) => (id) => {
        return state.sampleglassescategories.indexOf(id) > -1 ? true : false;
    },
    sampleCategoryGlassesInCart: (state) => (id) => {
        const count = () =>
            state.sampleglassescategories.filter((item) => item === id).length;
        return count();
    },
};

const actions = {
    addSampleGlas({ commit }, { cat, id, qty = 1 }) {
        commit("addSampleGlas", id);
        commit("addSampleGlassesCategory", cat);
    },
    removeSampleGlas({ commit }, { cat, id }) {
        commit("removeSampleGlas", id);
        commit("removeSampleGlassesCategory", cat);
    },
};

const mutations = {
    addSampleGlas(state, id) {
        const index = state.sampleglasses.indexOf(id);
        if (index == -1) {
            state.sampleglasses.push(id);
        }
    },

    removeSampleGlas(state, id) {
        const index = state.sampleglasses.indexOf(id);
        if (index > -1) {
            state.sampleglasses.splice(index, 1);
        }
    },

    addSampleGlassesCategory(state, id) {
        state.sampleglassescategories.push(id);
    },

    removeSampleGlassesCategory(state, id) {
        const index = state.sampleglassescategories.indexOf(id);
        if (index > -1) {
            state.sampleglassescategories.splice(index, 1);
        }
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
